const LoginStyles = {
  loginForm: {
    width: "100%",
    display: "grid",
    gap: "20px",
  },
  login: {
    width: "100%",
    minHeight: "100vh",
    display: "grid",
    gridTemplateColumns: "60% 40%",
    overflow: "hidden",
    "@media (max-width:599px)": {
      gridTemplateColumns: "100%",
      background:
        "linear-gradient(180deg, #FBFDFC 0%, #E5F6FE 100%),linear-gradient(180deg, #FBFDFC 0%, #B2E6FF 139.93%),linear-gradient(1.4deg, #BCC9CF -3.2%, #FFFFFF 32.82%)",
    },
  },
  loginImage: {
    height: "100%",
    width: "100%",
    position: "relative",
    img: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      objectPosition: "center",
    },
    video: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      objectPosition: "center",
    },
    "@media (max-width:599px)": {
      display: "none",
    },
  },
  loginCardContainer: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  logo: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    img: {
      maxWidth: "250px",
      maxHeight: "250px",
      objectFit: "contain",
    },
  },
  loginMessage: {
    fontFamily: "Playfair Display",
    fontSize: "20px",
    fontWeight: "400",
    lineHeight: "22px",
    color: "rgba(56, 61, 78, 1)",
  },
};

export default LoginStyles;
